import { render, staticRenderFns } from "./RateSupplier.vue?vue&type=template&id=1b70a918&"
import script from "./RateSupplier.vue?vue&type=script&lang=js&"
export * from "./RateSupplier.vue?vue&type=script&lang=js&"
import style0 from "./RateSupplier.vue?vue&type=style&index=0&id=1b70a918&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports